import UAParser from 'ua-parser-js'

export default {
  setUserAgent (state, userAgentString) {
    state.userAgent = new UAParser(userAgentString).getResult()
  }
}
